// extracted by mini-css-extract-plugin
module.exports = {"authOptions":"AuthOptionsComponent_authOptions__1ge_N","optionText":"AuthOptionsComponent_optionText___1gO6"};